/* eslint-disable jsx-a11y/click-events-have-key-events */
// The onClick handler is only used for tracking so it's not really interactive

import React from 'react';
import PropTypes from 'prop-types';

import { bemGenerator } from '@prisjakt/ui-base';

import './index.scss';

const styles = bemGenerator('pj-ui-chip');

const Chip = props => (
  <div
    role="button"
    className={styles.block.withModifier({
      active: props.active,
      selected: props.selected,
    })}
    onClick={props.onClick}
    tabIndex={0}
  >
    {props.children}
  </div>
);

Chip.defaultProps = {
  active: false,
  selected: false,
  onClick: () => {},
};

Chip.propTypes = {
  children: PropTypes.node.isRequired,
  active: PropTypes.bool,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Chip;
